<template>
  <section
    ref="articleSection"
    class="articles-section"
  >
    <div class="container">
      <div
        v-if="!isLeadgenPageCategory"
        class="items"
      >
        <template v-for="(chunk, index) in chunkedArticles">
          <div
            v-for="(card, cardIndex) in chunk"
            :key="`${index}-${cardIndex}`"
          >
            <ArticleCard
              v-if="card.page_type === CARD_TYPES.ARTICLE"
              :article="card"
            />
            <MemberStoryCard
              v-else-if="card.page_type === CARD_TYPES.MEMBER_STORY"
              :member="card"
            />
          </div>
          <div
            v-if="leadgenPages[index] && !category"
            :key="index"
            class="leadgen-page-card"
          >
            <LeadgenPageCard :page="leadgenPages[index]" />
          </div>
        </template>
      </div>
      <div
        v-else
        class="items"
      >
        <div
          v-for="(leadgen, index) in leadgenPages"
          :key="`leadgen-${index}`"
          class="leadgen-page-card"
        >
          <LeadgenPageCard :page="leadgen" />
        </div>
      </div>
      <div
        v-if="loading"
        class="loader"
      >
        <SpinnerIcon />
      </div>
      <button
        v-if="hasMore && !loading"
        class="load-more"
        @click="loadItems"
      >
        <span>Load More</span>
        <ChevronDownIcon stroke="5" />
      </button>
    </div>
  </section>
</template>

<script>
import MemberStoryCard from './MemberStoryCard/MemberStoryCard.vue';
import LeadgenPageCard from './LeadgenPageCard/LeadgenPageCard.vue';
import ArticleCard from '~/components/Common/ArticleCard/ArticleCard.vue';
import ChevronDownIcon from '~/components/Common/Svg/ChevronDownIconV2.vue';
import SpinnerIcon from '~/components/Common/Svg/SpinnerIcon.vue';
import { useJournalStore, CARD_TYPES } from '~/stores/journal';

export default {
  components: {
    LeadgenPageCard,
    ArticleCard,
    MemberStoryCard,
    ChevronDownIcon,
    SpinnerIcon,
  },
  data() {
    return {
      currentPage: 0,
      totalPages: 1,
      perPage: 12,
      CARD_TYPES,
      loading: false,
      journalStore: useJournalStore(),
      componentMounted: false,
    };
  },
  computed: {
    hasMore() {
      return (
        this.journalStore.hasMoreArticles ||
        this.journalStore.hasMoreLeadgenPages
      );
    },
    category() {
      return this.journalStore.category;
    },
    chunkedArticles() {
      return this.journalStore.chunkedArticles;
    },
    leadgenPages() {
      return this.journalStore.leadgenPages;
    },
    isLeadgenPageCategory() {
      return this.journalStore.isLeadgenPageCategory;
    },
  },
  watch: {
    async category() {
      if (!this.componentMounted) {
        return;
      }
      this.journalStore.resetArticles();
      this.journalStore.resetLeadgenPages();
      await this.loadItems(false);
      this.$refs.articleSection?.scrollIntoView({
        behavior: 'smooth',
      });
    },
  },
  created() {
    if (this.category && !this.$route.query.category) {
      this.$router.push({ query: { category: this.category } });
    }
  },
  mounted() {
    this.componentMounted = true;
  },
  methods: {
    async getArticleCards() {
      this.loading = true;

      try {
        const articles = await this.$cmsApi.get(
          '/cards',
          this.journalStore.filterParams
        );
        this.journalStore.setArticles(articles);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async getLeadgenPages() {
      this.loading = true;

      try {
        const leadgenPages = await this.$cmsApi.get(
          '/leadgen-pages',
          this.journalStore.leadgenFilterParams
        );
        this.journalStore.setLeadgenPages(leadgenPages);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    async loadItems(nextPage = true) {
      if (this.loading) {
        return;
      }

      if (!this.category || this.isLeadgenPageCategory) {
        if (nextPage && this.journalStore.hasMoreLeadgenPages) {
          this.journalStore.incrementCurrentPageLeadgen();
          await this.getLeadgenPages();
        }

        if (!nextPage) {
          await this.getLeadgenPages();
        }
      }

      if (!this.isLeadgenPageCategory) {
        if (nextPage && this.journalStore.hasMoreArticles) {
          this.journalStore.incrementCurrentPage();
          await this.getArticleCards();
        }

        if (!nextPage) {
          await this.getArticleCards();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './Articles.scss';
</style>
